import { render } from "./ModalRemoveJobTitle.vue?vue&type=template&id=6cf90f2f"
import script from "./ModalRemoveJobTitle.vue?vue&type=script&lang=js"
export * from "./ModalRemoveJobTitle.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__